/** Gemini model identifiers and role-specific defaults. */
export const GEMINI_MODELS = {
    FLASH_LITE_3_1: 'gemini-3.1-flash-lite',
    FLASH_LITE_3_5: 'gemini-3.5-flash-lite',
    FLASH_3_5: 'gemini-3.5-flash',
    FLASH_3_8: 'gemini-3.8-flash'
};
export const MODEL_TRANSLATIONS = GEMINI_MODELS.FLASH_LITE_3_1;
export const MODEL_EXTRACTION = GEMINI_MODELS.FLASH_LITE_3_5;
export const MODEL_SUMMARIZE_BASE = GEMINI_MODELS.FLASH_LITE_3_1;
export const MODEL_SUMMARIZE_BETTER = GEMINI_MODELS.FLASH_LITE_3_5;
export const MODEL_SUMMARIZE_BEST = GEMINI_MODELS.FLASH_3_8;
